import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'
import {InputText} from '@/components/commons/input-text/InputText'
import {TextArea} from '@/components/commons/textarea/TextArea'

export const StyledNewConversationForm = styled.form`
    display: flex;
    width: 100%;
`

export const StyledNewConversationFormInputsContainer = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        padding: ${spacing * 3}px ${spacing * 3}px ${spacing * 2}px;
        gap: ${spacing * 2}px;
    `
)

export const StyledNewConversationFieldGroup = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral[50]};
        border-radius: 8px;
        padding: ${spacing * 2}px ${spacing * 3}px;
    `
)

export const StyledNewConversationFieldLabel = styled.label(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        font-weight: 600;
        color: ${palette.neutral[900]};
    `
)

export const StyledNewConversationInputText = styled(InputText)<{inputSize?: 'sm' | 'md' | 'lg'}>(
    ({theme: {typography, palette}}) => css`
        & input {
            ${typography.textMd};
            background: transparent;

            &::placeholder {
                color: ${palette.neutral[500]};
            }
        }
        & div {
            box-shadow: none !important;
            outline: none !important;
            background: transparent !important;
            min-height: 40px;
            padding-left: 0;
            padding-right: 0;
        }
    `
)

export const StyledNewConversationTextArea = styled(TextArea)(
    ({theme: {typography, spacing, palette}}) => css`
        height: 100%;

        & textarea {
            padding: ${spacing * 2}px 0;
            ${typography.textMd};
            background: transparent;

            &::placeholder {
                color: ${palette.neutral[500]};
            }
        }

        & div {
            height: 100%;
            border: none !important;
            box-shadow: none !important;
            outline: none !important;
            background: transparent !important;
        }
    `
)

export const StyledNewConversationFormFooter = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        padding-top: ${spacing * 2}px;
        border-top: 1px solid ${palette.neutral[100]};
    `
)

export const StyledUrgentButton = styled(Button)<{$isActive?: boolean}>(
    ({theme: {palette}, $isActive}) => css`
        color: ${$isActive ? palette.warning[600] : palette.neutral[500]};
        &:hover {
            color: ${$isActive ? palette.warning[700] : palette.warning[600]};
        }
    `
)

export const StyledParticipantsInputContainer = styled.div(
    () => css`
        position: relative;
        width: 100%;
    `
)

export const StyledParticipantsDisplay = styled(Button)(
    ({theme: {typography, spacing, palette, borderRadius}}) => css`
        ${typography.textMd};
        min-height: 44px;
        padding: ${spacing * 2}px 0;
        border-radius: ${borderRadius}px;
        background-color: transparent;
        color: ${palette.neutral[900]};
        cursor: pointer;
        gap: ${spacing * 2}px;
        justify-content: flex-start;
        width: 100%;
        display: flex;
        align-items: center;

        & svg {
            color: ${palette.neutral[500]};
        }

        &:hover {
            background-color: ${palette.neutral[100]};
        }

        &:focus {
            background-color: transparent;
        }
    `
)

export const StyledParticipantsText = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[600]};
        text-align: start;
        &.has-selection {
            color: ${palette.neutral[900]};
            font-weight: 600;
        }
    `
)

export const StyledParticipantsAvatars = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        align-items: center;
        gap: -${spacing}px; /* Negative gap for overlapping avatars */
        flex-shrink: 0;
    `
)

export const StyledAddParticipantButton = styled(Button)(
    ({theme: {spacing}}) => css`
        position: absolute;
        right: ${spacing}px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
    `
)
